<template>
    <div
        class="MentoringReviews container my-10 flex w-full flex-col lg:mt-20"
        :class="{ 'mt-20': variant === 'side-by-side' }"
    >
        <div class="flex w-full flex-row flex-wrap justify-between">
            <h2 class="mb-6 text-left text-2xl font-black text-black dark:text-white lg:text-4xl lg:leading-[46.8px]">
                {{ title }}
            </h2>
            <!-- <div class="mt-4 hidden h-fit w-fit flex-row justify-center xl:flex">
                // prerobit potom ako CSwitch komponent
                <CButton
                    class="h-14 w-14 -scale-100"
                    icon="chevron-right"
                    :variant="page === 2 ? 'primary' : 'primary-outline'"
                    @click="page = 1"
                ></CButton>
                <CButton
                    class="ml-2 h-14 w-14"
                    icon="chevron-right"
                    :variant="page === 1 ? 'primary' : 'primary-outline'"
                    @click="page = 2"
                ></CButton>
            </div> -->
        </div>
        <div class="relative" :class="{ 'flex flex-col xl:flex-row': variant === 'side-by-side' }">
            <MentoringReviewCard
                v-if="page === 1"
                class="rounded-t-2xl border-b border-solid border-gray-200 dark:border-default xl:mb-48 xl:border-0"
                :class="{ 'xl:mb-12': variant === 'side-by-side' }"
                :review="review[0] as Record<string, any>"
            />
            <MentoringReviewCard
                v-if="page === 1"
                class="rounded-b-2xl"
                :class="{
                    'h-fit xl:relative xl:left-0 xl:top-0 xl:ml-4': variant === 'side-by-side',
                    'xl:absolute xl:left-[540px] xl:top-36': variant === 'overlap'
                }"
                :review="review[1] as Record<string, any>"
            />
            <!-- <MentoringReviewCard
                v-if="page === 2"
                class="rounded-2xl"
                :class="{ 'xl:mb-40': variant === 'side-by-side' }"
                :review="review[2]"
            /> -->
        </div>

        <!-- <div class="mt-10 flex h-fit w-full flex-row justify-end xl:hidden">
            <CButton
                class="h-14 w-14"
                icon="chevron-left"
                :variant="page === 2 ? 'primary' : 'primary-outline'"
                @click="page = 1"
            ></CButton>
            <CButton
                class="ml-2 h-14 w-14"
                icon="chevron-right"
                :variant="page === 1 ? 'primary' : 'primary-outline'"
                @click="page = 2"
            ></CButton>
        </div> -->
    </div>
</template>

<script setup lang="ts">
import MentoringReviewCard from '@/components/mentoring/MentoringReviewCard.vue'
import { ref } from 'vue'

defineProps({
    title: {
        type: String,
        default: ''
    },
    variant: {
        type: String,
        default: 'overlap'
    },
    review: {
        type: Array,
        default: () => []
    }
})

const page = ref(1)
</script>
